// select the correct language here
// import language from './../../src/common/i18n/et_EE.json';
// import language from './../../src/common/i18n/en_uk.json';

import language from "./../../src/common/i18n/fr_FR.json";

const dictionary = language;
// if needed change some strings here or add some
dictionary.notifications_title = "oops";
export default dictionary;



// WEBPACK FOOTER //
// ./clients/tel-tel/dictionary.js